import { FlameIcon, LayersIcon, ZapIcon, DropletsIcon, AppWindowIcon, PackageIcon, type LucideIcon } from "lucide-react";

export type Specialite = { icon: LucideIcon; title: string; text: string; href: string };

export const specialites: Specialite[] = [
  { icon: FlameIcon, title: "Chauffage", text: "Chauffage stationnaire pour voyager en toute saison.", href: "/specialites/chauffage" },
  { icon: LayersIcon, title: "Isolation", text: "Isolation premium, thermique et acoustique.", href: "/specialites/isolation" },
  { icon: ZapIcon, title: "Électricité", text: "Installation complète, batteries et panneaux solaires.", href: "/specialites/electricite" },
  { icon: DropletsIcon, title: "Gaz & Eau", text: "Réseaux gaz et eau conformes et fiables.", href: "/specialites/gaz-eau" },
  { icon: AppWindowIcon, title: "Pose de fenêtre", text: "Baies, lanterneaux et aérations étanches.", href: "/specialites/fenetres" },
  { icon: PackageIcon, title: "Accessoires", text: "Stores, porte-vélos, rangements et finitions.", href: "/specialites/accessoires" },
];
